<style>
/* Navbar fade transitions for AR fullscreen */
.navbar-fade-enter-active,
.navbar-fade-leave-active {
	transition: all 0.3s ease;
}

.navbar-fade-enter-from,
.navbar-fade-leave-to {
	opacity: 0;
	transform: translateY(-20px);
}
</style>

<template>
  <main>
    <transition name="navbar-fade" mode="out-in">
      <navbar v-if="!isArFullscreenActive"/>
    </transition>
	<transition name="fade" mode="out-in">
	  <slot/>
	</transition>
  </main>
</template>

<script>
import Navbar from '~/components/NavbarWeekly'

import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  components: {
    Navbar
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/check',
      user: 'auth/user',
    }),
    ...mapGetters('wizard', ['isArFullscreenActive'])
  },
}
</script>
